import "./index.css";
import React, { memo } from "react";
import { FaPlus, FaTerminal } from "react-icons/fa";
import { Handle } from "reactflow";

import { ValidatorFn } from "../../../helpers/validationConnector";

import { NodeHeader } from "../../Elements/NodeHeader";
import { NodeRef } from "../../Elements/NodeRef";

export default memo(({ data, ...rest }) => {
	return (
		<>
			<NodeRef nodeRef={data.ref} />
			<Handle type="target" position="left" isConnectable={true} isConnectableStart={false} />

			<NodeHeader
				rest={rest}
				data={data}
				icon={<FaTerminal />}
				text="Webhook"
			/>

			<div className="sendMessageContent">
				<div>{data.webhookUrl}</div>
			</div>

			<Handle
				type="source"
				position="right"
				id="web-success"
				className="handleTrue"
				isConnectable={true}
				isValidConnection={ValidatorFn()}
			>
				<FaPlus size={8} style={{ pointerEvents: "none" }} />
			</Handle>
			<Handle
				type="source"
				position="right"
				id="web-error"
				className="handleFalse"
				isConnectable={true}
				isValidConnection={ValidatorFn()}
			>
				<FaPlus size={8} style={{ pointerEvents: "none" }} />
			</Handle>
		</>
	);
});
